export default __webpack_public_path__ + "static/media/FG_10.5ccda41b.jpg";